import { useContext, useMemo } from 'react';

import { AuthContext } from '@/providers/auth/types';
import { ATLAS_USER_IDENTIFIER_CLAIM } from '@/utils/auth-claims';

export type UserInfo = {
  email: string | undefined;
  name: string | undefined;
  userId: string | undefined;
};

export const useUser = (): UserInfo => {
  const ctx = useContext(AuthContext);
  const userInfo = useMemo(() => {
    const userInfo: UserInfo = {
      email: ctx?.user?.email || undefined,
      name: ctx?.user?.name || undefined,
      userId: ctx?.user?.[ATLAS_USER_IDENTIFIER_CLAIM] || undefined,
    };

    return userInfo;
  }, [ctx?.user]);

  return userInfo;
};
